var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/crown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/crown_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7 18.9804H7.29999C6.87999 18.9804 6.40999 18.6504 6.26999 18.2504L2.12999 6.67035C1.53999 5.01035 2.22999 4.50035 3.64999 5.52035L7.54999 8.31035C8.19999 8.76035 8.93999 8.53035 9.21999 7.80035L10.98 3.11035C11.54 1.61035 12.47 1.61035 13.03 3.11035L14.79 7.80035C15.07 8.53035 15.81 8.76035 16.45 8.31035L20.11 5.70035C21.67 4.58035 22.42 5.15035 21.78 6.96035L17.74 18.2704C17.59 18.6504 17.12 18.9804 16.7 18.9804Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 22H17.5",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.5 14H14.5",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.5b68436aecb55fe911aee5882205b99e.svg";
export { ForwardRef as ReactComponent };